import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UserIdleModule } from 'angular-user-idle';
import { NgxSpinnerModule } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConfigService, ConfigurationServiceInitializerFactory } from './config/config.service';
import { CoreModule } from './core/core.module';
import { HttpErrorInterceptorInterceptor } from './core/interceptors/http-error-interceptor.interceptor';
import { SystemInterceptor } from './core/interceptors/system.interceptor';
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { BlankComponent } from './layouts/blank/blank.component';
import { LayoutComponent } from './layouts/layout/layout.component';
import { PrintComponent } from './layouts/print/print.component';
import { ApiModule, BASE_PATH, Configuration } from './open-api';
import { BlankFullComponent } from './layouts/blank-full/blank-full.component';
import { DatePipe, DecimalPipe } from '@angular/common';
import { BlankNewComponent } from './layouts/blank-new/blank-new.component';
import { IpCountryInterceptor } from './core/interceptors/ip-contry.interceptor';


export function configuratioFactory() { return new Configuration({ basePath: environment.apiUrl }); }
@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    BlankComponent,
    PrintComponent,
    BlankFullComponent,
    BlankNewComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    ApiModule.forRoot(configuratioFactory),
    CoreModule,
    NgxSpinnerModule,
    NgbModalModule,
    UserIdleModule.forRoot({ idle: 600, timeout: 5, ping: 60 }),
  ],
  providers: [
    DecimalPipe,
    DatePipe,
    {
      provide: APP_INITIALIZER,
      useFactory: ConfigurationServiceInitializerFactory,
      deps: [ConfigService, HttpClient],
      multi: true
    },
    {
      provide: BASE_PATH,
      useValue: environment.apiUrl
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: IpCountryInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SystemInterceptor,
      multi: true
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
